module.exports = __webpack_public_path__ + "img/audio-pause.10e10ecc.png";